import React from 'react';
import Img from 'graphcms-image';
import classnames from 'classnames';

const Authors = ({ people, expand = true, showTitle = false }) =>
  people.map(({ name, photo: image, title }, index) => (
    <span
      className={classnames('inline-flex items-center relative z-10', {
        'mx-3': expand,
        '-mr-5 first:z-20 last:mr-0 last:z-0': !expand,
      })}
      key={index}
    >
      {image && (
        <Img
          image={image}
          title={name}
          alt={name}
          className={classnames(
            'flex w-10 h-10 rounded-full border-2 border-white',
            {
              'mr-3': expand,
            }
          )}
          outerWrapperClassName="inline-flex"
          maxWidth={150}
          transforms={['quality=value:75']}
          withWebp
        />
      )}

      {expand && (
        <div className="text-sm md:text-base">
          {name}
          {showTitle && title && (
            <span className="text-cornflower text-xs uppercase font-bold block">
              {title}
            </span>
          )}
        </div>
      )}
    </span>
  ));

export default Authors;
